/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Flex } from '@chakra-ui/react';
import { type FunctionComponent } from 'react';
import { type Request } from '../../interface/Crash';
import { type RequestMethod, RequestMethodTag, RequestStatusTag, RequestTypeTag, RequestUrlTag } from '../RequestTags';

interface Props {
    request: Request;
}

export const BKTraceRequest: FunctionComponent<Props> = (props: Props) => {
    const { request } = props;
    return (
        <Flex flexWrap="wrap" gap={2} alignItems="center">
            {request.type && <RequestTypeTag value={request.type} />}
            {request.method && <RequestMethodTag value={request.method as RequestMethod} />}
            {request.response?.code != null && <RequestStatusTag value={request.response.code} />}
            {request.url && <RequestUrlTag value={request.url} />}
        </Flex>
    );
};
